import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { MediaManagerBoard } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import MediaManagerBoardListElement from 'modules/manager/ui/components/media-manager-board-list-element';
import React from 'react';
import { ClipLoader } from 'react-spinners';
import { UDButton, UDText } from 'ud-ui/components';
import ListView from 'ud-ui/components/list-view/list-view';

const HEADER_NAME = 'Табло';

interface IProps {
  boards: MediaManagerBoard[];
  isLoading?: boolean;
  className?: string;

  onCreate: () => void;
  onSelect: (board: MediaManagerBoard) => void;
  onEdit: (board: MediaManagerBoard) => void;
  onDelete: (board: MediaManagerBoard) => void;
}

function MediaManagerBoardList(props: IProps) {
  const { boards, isLoading, className, onCreate, onSelect, onEdit, onDelete } = props;
  const nodeClasses = classNames(className, 'flex-1');
  const isEmpty = boards?.length === 0;

  if (isLoading) {
    return (
      <ListView header={HEADER_NAME} className={nodeClasses}>
        <div className={'flex-center h-full bg-white'}>
          <ClipLoader />
        </div>
      </ListView>
    );
  }

  if (isEmpty) {
    return (
      <ListView header={HEADER_NAME} className={nodeClasses}>
        <div className={'flex-center flex h-full flex-col gap-2 bg-white'}>
          <UDText isNew type={'body-2'}>
            У вас ещё нет табло
          </UDText>
          <UDButton variant="primary" onClick={onCreate}>
            <Plus size={16} className={'mr-2'} /> Добавить табло
          </UDButton>
        </div>
      </ListView>
    );
  }

  return (
    <ListView header={HEADER_NAME} className={nodeClasses}>
      <div className={'h-full bg-white'}>
        {boards?.map((board, index) => (
          <MediaManagerBoardListElement
            key={board.id}
            id={board.id}
            name={board.name}
            background={index % 2 === 0 ? 'light' : 'dark'}
            onClick={() => onSelect(board)}
            onEdit={() => onEdit(board)}
            onDelete={() => onDelete(board)}
          />
        ))}
      </div>
    </ListView>
  );
}

export default MediaManagerBoardList;
